<template>
  <div>
    <div
      v-if="requestList.length"
      class="table-responsive"
    >
      <table class="table table-bordered table-striped table-vcenter">
        <thead class="table-dark">
          <tr>
            <th>Update History</th>
            <th>
              {{ editable ? "Update Payment" : "Paid Status" }}
            </th>
            <th>Head Hunting</th>
            <th>Remarks</th>
            <th>Project Title</th>
            <th>Expert Name</th>
            <th>Expert Phone Number</th>
            <th>Expert Primary Email Address</th>
            <th>Expert Secondary Email Address</th>
            <!--            <th>Call Duration</th>
                                                                                                                                        <th>Hourly Rate</th>
                                                                                                                                        <th>Payment to Expert</th>
                                                                                                                                        <th>Within 48 hours</th>
                                                                                                                                        <th>Follow up</th>
                                                                                                                                        <th>Staff Credits</th>
                                                                                                                                        <th>Requestor</th>
                                                                                                                                        <th>Hourly Credits to Charge Client</th>-->
            <th v-if="editable" />
          </tr>
        </thead>
        <tbody
          v-for="request in requestList"
          :key="request.id"
        >
          <tr>
            <!--                  show history column-->
            <td>
              <div>
                <button
                  v-b-modal="`request-log-modal-${request.id}`"
                  class="btn btn-sm btn-info"
                  @click="openLogModal(request.id)"
                >
                  Show history
                </button>

                <b-modal
                  :id="`request-log-modal-${request.id}`"
                  title="Request update history"
                  class="modal"
                  tabindex="-1"
                >
                  <template #modal-header="{ close }">
                    <h5>Request update history</h5>
                    <button
                      type="button"
                      class="btn-close"
                      @click="close()"
                    />
                  </template>
                  <!--                  <div class="modal-dialog modal-xl">
                                                                                                                                                      <div class="modal-content">
                                                                                                                                                        <div class="modal-header">
                                                                                                                                                          <h5 class="modal-title">
                                                                                                                                                            Request update history
                                                                                                                                                          </h5>
                                                                                                                                                          <button
                                                                                                                                                            type="button"
                                                                                                                                                            class="btn-close"
                                                                                                                                                            data-bs-dismiss="modal"
                                                                                                                                                            aria-label="Close"
                                                                                                                                                          />
                                                                                                                                                        </div>

                                                                                                                                                        <div class="modal-body">-->
                  <b-container>
                    <payment-request-update-logs
                      :request-logs="getRequestLogs(request)"
                    />
                  </b-container>
                  <!--                      </div>
                                                                                                                                                        <div class="modal-footer">
                                                                                                                                                          <button
                                                                                                                                                            type="button"
                                                                                                                                                            class="btn btn-secondary"
                                                                                                                                                            data-bs-dismiss="modal"
                                                                                                                                                          >
                                                                                                                                                            Close
                                                                                                                                                          </button>
                                                                                                                                                        </div>
                                                                                                                                                      </div>
                                                                                                                                                    </div>-->
                </b-modal>
              </div>
            </td>

            <!--                  update payment column-->
            <td>
              <!-- Button trigger modal -->
              <div v-if="editable">
                <!--                <button
                                                                                                                                                      type="button"
                                                                                                                                                      :class="`btn ${getRequestPaidStatus(request) ? 'btn-primary' : 'btn-outline-primary' }`"
                                                                                                                                                      :disabled="request.head_hunting === 1"
                                                                                                                                                      @click="openPaymentUpdateModal(request.id)"
                                                                                                                                                    >
                                                                                                                                                      {{ getRequestPaidStatus(request) ? "Payment Updated" : "Update Payment" }}
                                                                                                                                                    </button>-->
                <PaymentUpdateModal
                  :request="request"
                  @payment-updated="fetchRequests"
                />
              </div>
              <div v-else>
                {{ getRequestPaidStatus(request) ? "Paid" : "Unpaid" }}
              </div>

              <!-- Modal -->
              <!--              <div
                                                                                                                              :id="`payment-update-modal-${request.id}`"
                                                                                                                              :ref="`paymentUpdateModal${request.id}`"
                                                                                                                              class="modal fade"
                                                                                                                              tabindex="-1"
                                                                                                                              :aria-labelledby="`paymentModalLabel${request.id}`"
                                                                                                                              aria-hidden="true"
                                                                                                                            >
                                                                                                                              <div class="modal-dialog">
                                                                                                                                <div class="modal-content">
                                                                                                                                  <div class="modal-header">
                                                                                                                                    <h1
                                                                                                                                      :id="`paymentModalLabel${request.id}`"
                                                                                                                                      class="modal-title fs-5"
                                                                                                                                    >
                                                                                                                                      Paid
                                                                                                                                    </h1>
                                                                                                                                    <button
                                                                                                                                      type="button"
                                                                                                                                      class="btn-close"
                                                                                                                                      data-bs-dismiss="modal"
                                                                                                                                      aria-label="Close"
                                                                                                                                    />
                                                                                                                                  </div>
                                                                                                                                  <div class="modal-body">
                                                                                                                                    <div class="input-group">
                                                                                                                                      <input
                                                                                                                                        :id="`payment-url-${request.id}`"
                                                                                                                                        :value="request.payment_url"
                                                                                                                                        type="text"
                                                                                                                                        class="form-control"
                                                                                                                                        placeholder="Payment URL"
                                                                                                                                        aria-label="Payment URL"
                                                                                                                                        aria-describedby="button-payment-url"
                                                                                                                                      >
                                                                                                                                      <button
                                                                                                                                        :class="`btn ${getRequestPaidStatus(request) ? 'btn-success' : 'btn-info'}`"
                                                                                                                                        :disabled="isUpdatingRequest(request)"
                                                                                                                                        @click="setPaymentStatus(request)"
                                                                                                                                      >
                                                                                                                                        {{ getRequestPaidStatus(request) ? "Undo" : "Paid" }}
                                                                                                                                        <span
                                                                                                                                          v-if="isUpdatingRequest(request)"
                                                                                                                                          class="spinner-grow spinner-grow-sm"
                                                                                                                                          role="status"
                                                                                                                                          aria-hidden="true"
                                                                                                                                        />
                                                                                                                                      </button>
                                                                                                                                    </div>
                                                                                                                                  </div>
                                                                                                                                  <div class="modal-footer">
                                                                                                                                    <button
                                                                                                                                      type="button"
                                                                                                                                      class="btn btn-secondary"
                                                                                                                                      data-bs-dismiss="modal"
                                                                                                                                    >
                                                                                                                                      Close
                                                                                                                                    </button>
                                                                                                                                  </div>
                                                                                                                                </div>
                                                                                                                              </div>
                                                                                                                            </div>-->
            </td>
            <!--                  head hunting column-->
            <td>{{ request.head_hunting === 1 ? "Yes" : "No" }}</td>
            <!-- Remarks Column -->
            <td>
              {{ request.remarks }}
            </td>
            <!--                  project title column-->
            <td>
              <a
                :href="request.project.admin_detail_url"
                target="_blank"
              >{{ request.project.project_title }}</a>
            </td>
            <!--                  expert name column-->
            <td>
              <a
                :href="request.assignment.expert.admin_profile_url"
                target="_blank"
              >{{ request.assignment.expert.user.full_name }}</a>
            </td>
            <!-- expert phone number column -->
            <td>
              {{ "+" + request.assignment.expert.user.full_mobile_phone }}
            </td>
            <td>{{ request.assignment.expert.user.email }}</td>
            <td>
              {{ request.assignment.expert.user.email_2 }}
            </td>
            <!--            <td>{{ request.duration !== null ? `${request.duration} minutes` : "" }}</td>
                                                                                                                                        <td>{{ request.hourly_rate !== null ? `${request.hourly_rate} USD` : "" }}</td>
                                                                                                                                        <td>{{ request.payment_to_expert > 0 ? `${request.payment_to_expert_formatted} USD` : "" }}</td>
                                                                                                                                        <td>{{ request.in_hours === 1 ? "Yes" : "No" }}</td>
                                                                                                                                        <td>{{ request.follow_up_consult === 1 ? "Yes" : "No" }}</td>
                                                                                                                                        <td>{{ request.credits }}</td>
                                                                                                                                        <td>{{ request.requestor }}</td>
                                                                                                                                        <td>{{ request.client_hourly_credit }}</td>-->
            <td v-if="editable">
              <button
                class="btn btn-info"
                @click="showRequestModal(request)"
              >
                Edit
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="10">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Call Duration</th>
                    <th>Hourly Rate</th>
                    <th>Payment to Expert</th>
                    <th>Within 48 hours</th>
                    <th>Follow up</th>
                    <th>Staff Credits</th>
                    <th>Requestor</th>
                    <th>Hourly Credits to Charge Client</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <!--                  request date column-->
                    <td>{{ $moment(request.requested_time).format("DD MMM YYYY") }}</td>
                    <td>{{ request.duration !== null ? `${request.duration} minutes` : "" }}</td>
                    <td>{{ request.hourly_rate !== null ? `${request.hourly_rate} USD` : "" }}</td>
                    <td>
                      {{ request.payment_to_expert > 0 ? `${request.payment_to_expert_formatted} USD` : ""
                      }}
                    </td>
                    <td>{{ request.in_hours === 1 ? "Yes" : "No" }}</td>
                    <td>{{ request.follow_up_consult === 1 ? "Yes" : "No" }}</td>
                    <td>{{ request.credits }}</td>
                    <td>{{ request.requestor }}</td>
                    <td>{{ request.client_hourly_credit }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <!--          <tr>
                                                                                            <td colspan="9">
                                                                                                <table class="table mb-0">
                                                                                                    <thead>
                                                                                                    <th>Call Duration</th>
                                                                                                    <th>Hourly Rate</th>
                                                                                                    <th>Payment to Expert</th>
                                                                                                    <th>Within 48 hours</th>
                                                                                                    <th>Follow up</th>
                                                                                                    <th>Staff Credits</th>
                                                                                                    <th>Requestor</th>
                                                                                                    <th>Hourly Credits to Charge Client</th>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                    <tr>
                                                                                                        <td>{{ request.duration !== null ? `${request.duration} minutes` : "" }}</td>
                                                                                                        <td>{{ request.hourly_rate !== null ? `${request.hourly_rate} USD` : "" }}</td>
                                                                                                        <td>{{ request.payment_to_expert > 0 ? `${request.payment_to_expert_formatted} USD` : "" }}</td>
                                                                                                        <td>{{ request.in_hours === 1 ? "Yes" : "No" }}</td>
                                                                                                        <td>{{ request.follow_up_consult === 1 ? "Yes" : "No" }}</td>
                                                                                                        <td>{{ request.credits }}</td>
                                                                                                        <td>{{ request.requestor }}</td>
                                                                                                        <td>{{ request.client_hourly_credit }}</td>
                                                                                                    </tr>
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </td>
                                                                                        </tr>-->
        </tbody>
      </table>
    </div>
    <div v-else>
      <div class="alert alert-info">
        No requests found
      </div>
    </div>
    <!-- eof request list -->
    <!-- BOF edit request modal -->
    <div
      id="edit-request-modal"
      ref="editRequestModal"
      class="modal"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Requested Payments
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <form
            ref="creditForm"
            @submit="submitCreditForm"
          >
            <div class="modal-body">
              <div class="mb-3">
                <label
                  for="creditInput"
                  class="form-label"
                >Credits</label>
                <input
                  id="creditInput"
                  v-model="selectedCredits"
                  type="number"
                  step="0.1"
                  min="0"
                  required
                  name="credits"
                  class="form-control"
                  aria-describedby="emailHelp"
                >
              </div>

              <div class="mb-3 form-check">
                <input
                  id="inHourCheck"
                  v-model="selectedInHour"
                  type="checkbox"
                  name="in_hours"
                  class="form-check-input"
                >
                <label
                  class="form-check-label"
                  for="inHourCheck"
                >is 48 hours</label>
              </div>

              <input
                type="hidden"
                name="request_id"
                :value="selectedRequest.id"
              >
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="updatingCredits"
              >
                Update
                <div
                  v-if="updatingCredits"
                  class="spinner-grow spinner-grow-sm"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- EOF edit request modal -->
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import moment from "moment-timezone";
import PaymentUpdateModal from "./PaymentUpdateModal.vue";

export default {
    name: "PaymentRequestListTable",
    components: { PaymentUpdateModal },
    props: {
        isAdmin: {
            type: Boolean,
            default: false,
        },
        requestList: {
            type: Array,
            required: true,
        },
        editable: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: function() {
        return {
            updatingCredits: false,
            selectedRequest: {},
            selectedCredits: null,
            selectedInHour: false,
            // requestUpdatingStatuses: [],
            paymentUpdateModal: null,
        };
    },
    computed: {
        editRequestModal() {
            return new Modal(this.$refs.editRequestModal);
        },
    },
    methods: {
        fetchRequests() {
            return this.$emit("fetch-requests");
        },
        showRequestModal(request) {
            this.selectedRequest = request;
            this.selectedCredits = request.credits;
            this.selectedInHour = request.in_hours === 1;
            this.editRequestModal.show();
        },
        getRequestPaidStatus(request) {
            return request.paid === 1;
        },
        /*setPaymentStatus(request) {
            const status = request.paid === 1 ? 0 : 1;
            const requestId = request.id;
            const paymentUrl = document.getElementById(`payment-url-${requestId}`).value;

            this.requestUpdatingStatuses.push(requestId);
            this.$store.dispatch("credit/updateRequestStatus", {
                requestId: requestId,
                status: status,
                paymentUrl: paymentUrl,
            }).then((response) => {
                alert("Payment updated successfully");
            }).catch((error) => {
                console.log(error);
                alert("Something went wrong");
            }).finally(async () => {
                this.requestUpdatingStatuses = [];
                this.fetchRequests();
                await this.paymentUpdateModal.hide();
                this.paymentUpdateModal = null;
            });
        },*/
        openPaymentUpdateModal(requestId) {
            this.paymentUpdateModal = new Modal(document.getElementById(`payment-update-modal-${requestId}`));
            this.paymentUpdateModal.show();
        },
        getRequestLogs(request) {
            return request?.update_logs ?? [];
        },
        openLogModal(requestId) {
            const modal = new Modal(document.getElementById(`request-log-modal-${requestId}`));
            modal.show();
        },
        submitCreditForm(e) {
            e.preventDefault();
            if (this.selectedCredits === null) {
                alert("Please enter credits");
                return;
            }

            const formData = new FormData(this.$refs.creditForm);
            this.updateCreditRequest(formData, this.staffId);
        },
        updateCreditRequest(formData) {
            this.updatingCredits = true;

            this.$store.dispatch("credit/updateRequestCredits", {
                formData: formData,
            }).then((response) => {
                this.fetchRequests();
                alert("Updated successfully");
            }).catch((error) => {
                console.log(error);
                alert("Something went wrong");
            }).finally(() => {
                this.updatingCredits = false;
                this.editRequestModal.hide();
            });
        },
    },
};
</script>

